"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.languageToISO = void 0;
var language_1 = require("./language/language");
Object.defineProperty(exports, "languageToISO", { enumerable: true, get: function () { return language_1.languageToISO; } });
